// @ts-nocheck
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Orders, { orderTypes } from './components/Orders';
import { RouteComponent } from '../../lib/routerAdapter';

const IncomeOrders = (props) => <Orders type={orderTypes.income} {...props} />;
const ArchiveOrders = (props) => <Orders type={orderTypes.archive} {...props} />;

export default () =>
<Routes>
    <Route index element={<RouteComponent component={IncomeOrders} />} />
    <Route path="archive" element={<RouteComponent component={ArchiveOrders} />} />
  </Routes>;